import React, { useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { updateInternalCode } from '../../../../store/NumberManagementSlice';
import { validations } from '../../../../config/validations/validations';

const UpdateForm: React.FC<any> = (props) => {
  const { openUpdateModal, handleUpdateRequest, openUpdateData, getList } =
    props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (openUpdateData) {
      form.setFieldValue('name', openUpdateData?.code_name);
      form.setFieldValue('description', openUpdateData?.description);
    }
  }, [openUpdateData, form]);

  const handleSubmit = (data) => {
    const payload = {
      ...data,
      id: openUpdateData?._id,
    };
    dispatch(updateInternalCode(payload))
      .then(() => {
        handleUpdateRequest();
        getList();
      })
      .catch(() => {
        handleUpdateRequest();
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <Modal
        open={openUpdateModal}
        destroyOnClose
        width={800}
        onCancel={handleUpdateRequest}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className='addModal'
        title={`Update Provider Code Request`}>
        <FormBox
          className='filterForm'
          form={form}
          onFinish={handleSubmit}
          onChange={handleChange}
          validateTrigger={['onBlur', 'onInput']}
          autoComplete='off'>
          <Row gutter={20} align={'top'}>
            <Col xs={24} md={12}>
              <InputBox.Text
                label='Name'
                name={'name'}
                rules={[validations.pattern.whitespace]}
              />
            </Col>
            <Col xs={24} md={12}>
              <InputBox.Text
                label='Description'
                name={'description'}
                rules={[validations.pattern.whitespace]}
              />
            </Col>
            <Col xs={12} md={12}>
              {/* <Form.Item label=' '> */}
              <Button type='primary' htmlType='submit'>
                Submit
              </Button>
              {/* </Form.Item> */}
            </Col>
          </Row>
        </FormBox>
      </Modal>
    </>
  );
};

export default UpdateForm;
